import { createContext } from 'react';
import type { IServiceOrganizationSettings } from '@frontend/components/interfaces/serviceOrganizationSettings';

export interface IServiceOrganizationSettingContext {
    reloadServiceOrganizationSettings: () => Promise<void>;
    serviceOrganizationSetting: IServiceOrganizationSettings;
}

export const ServiceOrganizationSettingContext = createContext<IServiceOrganizationSettingContext | null>(null);
